import React, { useEffect, useState } from 'react'
import {
    Box,
    Button,
    CircularProgress,
    Paper,
    Skeleton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material'

import { FullNodeProp, UserData } from '../../../utils/types'
import { get, post } from '../../../utils/http'

interface PredictionFormProps {
    slideData: FullNodeProp,
    closeShareModal: Function,
    updateMainTree: Function,
    updateMountedTree: Function
}

const ShareSlide = ({ slideData, closeShareModal, updateMainTree, updateMountedTree,  }: PredictionFormProps) => {
    const [userList, setUserList] =  useState<UserData[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const userEmail = localStorage.getItem('user_email')
    const userId: number = Number(localStorage.getItem('user_id') || '1')

    const getNodeData = async () => {
        try {
            const users: UserData[]  = await get(`Users/list/${userEmail}`)
            const node = await get(`shared-tree/node/${slideData.id}`)
            const temp: UserData[] = users.filter(i => i.id !== userId).sort((a, b) => a.id - b.id)
            if (node && node.node_data) {
                setUserList(temp.map(i => ({...i, check: node.shared_users.includes(i.id)})))
            } else setUserList(temp.map(i => ({...i, check: false})))
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getNodeData()
    }, [slideData]) // eslint-disable-line

    const toggleUsers = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        setUserList(prevList => {
            const temp = [...prevList]
            temp[index].check = e.target.checked
            return temp
        })
    }

    const shareNode = async () => {
        setLoading(true)
        try {
            const temp: number[] = userList.filter(i => i.check === true).map(i => i.id)
            if (slideData.name.startsWith('My Folder/')) {
                const res = await post('user-tree/share', { user_id: userId, name: slideData.name, shared_users: temp })
                updateMainTree(res)
            } else if (slideData.name.startsWith('Mounts/')) {
                const res = await post('user-mounted-tree/share', { user_id: userId, name: slideData.name, shared_users: temp })
                updateMountedTree(res)
            }
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
            closeShareModal()
        }
    }

    return (
        <Box className='d-flex flex-column gap-4'>
            <Typography variant="h5" component="h1">{slideData.name.endsWith('/') ? "Share folder" : "Share file"}</Typography>
            {userList.length
                ? <>
                    <Box className='d-flex flex-column gap-2'>
                        <Typography variant='caption'>{slideData.name.split('/').filter(Boolean).pop()}</Typography>
                        <TableContainer component={Paper}>
                            <Table size="small" aria-label="user table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell align="right">Email</TableCell>
                                        <TableCell align="right">Selected</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {userList.map((u, index) => (
                                    <TableRow key={u.id}>
                                        <TableCell component="th" scope="row">{u.first_name} {u.last_name}</TableCell>
                                        <TableCell align="right">{u.email}</TableCell>
                                        <TableCell>
                                            <input className='form-check-input' type='checkbox' onChange={(e) => toggleUsers(e, index)} defaultChecked={u.check} />
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box className='d-flex gap-3 justify-content-end'>
                        {loading
                            ? <CircularProgress size={30} />
                            : <>
                                <Button variant="outlined" onClick={() => closeShareModal()}>Close</Button>
                                <Button variant="contained" onClick={shareNode}>Submit</Button>
                            </>
                        }
                    </Box>
                </>
                : <Stack spacing={1}>
                    {Array.from({length: 3}, (_, i) => i).map(i => (<Skeleton key={i} variant="rectangular" height={34} />))}
                </Stack>
            }
        </Box>
    )
}

export default ShareSlide